import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import kelompokTenagaService from "../../../services/ref/kelompokTenagaService";
import Cookies from "js-cookie";

export const initialState = {
    loading_kelompok_tenaga: false,
    data_kelompok_tenaga: [],
    showMessage:false,
    message:'',
}


export const getDataKelompokTenaga = createAsyncThunk('kelompok_tenaga/data',async (data, { rejectWithValue }) => {
    try {
        const response = await kelompokTenagaService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const kelompokTenagaSlice = createSlice({
    name: 'kelompok_tenaga',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_kelompok_tenaga = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKelompokTenaga.fulfilled, (state, action) => {
                state.loading_kelompok_tenaga = false
                state.data_kelompok_tenaga = action.payload??[]
            })
            .addCase(getDataKelompokTenaga.pending, (state) => {
                state.loading_kelompok_tenaga = true
            })
            .addCase(getDataKelompokTenaga.rejected, (state, action) => {
                state.loading_kelompok_tenaga = false
                state.data_kelompok_tenaga = action.payload
            })
    },
})

export const {
    showLoading,
} = kelompokTenagaSlice.actions

export default kelompokTenagaSlice.reducer
